/**
 * The read-only plugin.
 *
 * This is a "glue" plugin that loads the following plugins:
 *
 * * The {@link module:read-only/readonlyediting~ReadOnlyEditing read-only feature}.
 * * The {@link module:read-only/readonlyui~ReadOnlyUI read-only UI feature}.
 *
 * @extends module:core/plugin~Plugin
 */
import { Plugin } from 'ckeditor5';

import ReadOnlyEditing from './readonlyediting';
import ReadOnlyUI from './readonlyui';

export default class ReadOnly extends Plugin {
    /**
     * @inheritDoc
     */
    static get pluginName() {
        return 'ReadOnly';
    }

    static get requires() {
        return [ReadOnlyEditing, ReadOnlyUI];
    }
}
